import { InjectionToken } from '@angular/core';
import {
  AuthErrorPresenter,
  AuthHostServiceConfig,
  AuthInterceptorConfig,
  AuthLogger,
  AuthRemoteServiceConfig,
} from './models';

export const AUTH_HOST_SERVICE_CONFIG =
  new InjectionToken<AuthHostServiceConfig>('AUTH_HOST_SERVICE_CONFIG');
export const AUTH_REMOTE_SERVICE_CONFIG =
  new InjectionToken<AuthRemoteServiceConfig>('AUTH_REMOTE_SERVICE_CONFIG');
export const AUTH_HOST_LOGGER = new InjectionToken<AuthLogger>(
  'AUTH_HOST_LOGGER',
);
export const AUTH_HOST_ERROR_PRESENTER = new InjectionToken<AuthErrorPresenter>(
  'AUTH_HOST_ERROR_PRESENTER',
);
export const AUTH_INTERCEPTOR_CONFIG =
  new InjectionToken<AuthInterceptorConfig>('AUTH_INTERCEPTOR_CONFIG');
export const AUTH_IDENTITY_SERVER_URL = new InjectionToken<string>(
  'AUTH_IDENTITY_SERVER_URL',
);
